module.exports = [
    { name: 'Date Sent', reordable: true, id: 'createdAt' },
    { name: 'Name', reordable: true, id: 'name' },
    { name: 'Subject', reordable: true, id: 'subject' },
    { name: 'Channel', reordable: true, id: 'channel' },
    { name: 'Message type', reordable: true, id: 'messageType' },
    { name: 'Status', reordable: true, id: 'status' }
];
